module.exports = __webpack_public_path__ + "static/media/alyssa.5cc68a7c.jpg";